import { type FC } from 'react'
import { Form } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { type Location } from '../../../models/Scheduling'
import { schedulingSetupPath } from './bookingNavigation'
import { buildEventTypeLocationOptions, eventTypeLocationPatch } from './eventTypeOptions'
import { useDefaultLocationPreviews } from './useDefaultLocationPreviews'

interface EventTypeLocationFieldProps {
  id: string
  locations: Location[]
  value: string
  onChange: (value: string) => void
}

export const EventTypeLocationField: FC<EventTypeLocationFieldProps> = ({ id, locations, value, onChange }) => {
  const { accountDefaultLocation, userDefaultLocation } = useDefaultLocationPreviews(locations)
  const options = buildEventTypeLocationOptions(locations, accountDefaultLocation, userDefaultLocation, eventTypeLocationPatch(value))

  return (
    <div className='d-flex flex-column zocks-gap-0.25'>
      <label className='bold' htmlFor={id}>
        Location
      </label>
      {options.length > 0 ? (
        <Form.Select id={id} value={value} onChange={(event) => onChange(event.currentTarget.value)}>
          <option value=''>Select location</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Form.Select>
      ) : (
        <div role='status' className='d-flex align-items-start zocks-gap-0.75 px-3 zocks-py-0.75 border border-warning rounded-3 zocks-bg-color-warning'>
          <i className='bi bi-exclamation-triangle-fill zocks-text-warning-dark pt-1' aria-hidden='true' />
          <div className='d-flex flex-column zocks-gap-0.125 zocks-text-gray-900'>
            <span className='paragraph-medium-extended fw-semibold'>No in-person locations yet</span>
            <span className='paragraph-medium'>
              Add one in{' '}
              <Link to={schedulingSetupPath} state={{ section: 'availability' }} className='zocks-text-primary text-decoration-underline'>
                Scheduling settings
              </Link>{' '}
              to create this event type. Or choose Virtual.
            </span>
          </div>
        </div>
      )}
    </div>
  )
}
